// extracted by mini-css-extract-plugin
export default {"header":"TableGroup_header__ahg8F"};